export const buildExtraQuestionsStr = (extraQuestions) => {
  if (extraQuestions.length) {
    const start_str = `\n     extraQuestions: [`
    let str = start_str
    extraQuestions.forEach((extraQuestion, idx) => {
      const questionArr = Object.keys(extraQuestion)
      const anyFieldsEmpty = questionArr.filter(field => extraQuestion[field].value === '').length !== 0
      str += anyFieldsEmpty
        ? ''
        : `{\n       question: "${extraQuestion.question.value}",
       keyname: "${extraQuestion.keyname.value}",
       option1: "${extraQuestion.option1.value}",
       option2: "${extraQuestion.option2.value}",
     }${idx === extraQuestions.length - 1 ? '' : ', '}`
    })
    const result_str = str + `],`
    return str === start_str ? '' : result_str
  } else {
    return ''
  }
}

export const buildOptionsStr = (widgetOptions, messageOptions) => {
  const allOptions = { ...widgetOptions, ...messageOptions };
  return Object.keys(allOptions).reduce((str, option) => {
    const optionValue = allOptions[option].value;
    const optionStr = optionValue ? (
      typeof allOptions[option].textInput !== 'undefined'
        ? `\n     ${option}: "${allOptions[option].textInput}",`
        : `\n     ${option}: ${optionValue},`
    ) : '';
    return str + optionStr;
  }, '');
};

export const buildBrandNameStr = brandName =>
  brandName ? `\n     brandName: "${brandName}",` : ''

export const buildCustomTimeBoundsStr = (customTimeBoundsStart, customTimeBoundsEnd) =>
  customTimeBoundsStart || customTimeBoundsEnd ? `\n     customTimeBounds: [${customTimeBoundsStart}, ${customTimeBoundsEnd}],` : ''

export const buildSelectedLocationsStr = selectedLocations =>
  selectedLocations.length
    ? `\n     specificLocations: ${JSON.stringify(selectedLocations)},`
    : ''

export const buildContactPhoneStr = (options) =>
  options.contactPhoneNumber && options.contactPhoneNumber.value
    ? `\n     contactPhoneNumber: "${options.contactPhoneNumber.textInput}",`
    : '';

export const buildTextAreaLabelStr = textAreaLabel =>
  textAreaLabel ? `\n     textAreaLabel: "${textAreaLabel}",` : ''

const buildFilterOptionStr = filterOptions =>
  filterOptions.reduce((str, option) => {
    const optionObj = `\n       "${option.button.value}": ${JSON.stringify(
      option.apptTypes,
    )},    `
    return str + optionObj
  }, '')

export const buildFilterObjStr = filterOptions => {
  const noEmptyFields =
    filterOptions.filter(
      field => field.button.value !== '' && field.apptTypes.length !== 0,
    ).length === filterOptions.length
  return noEmptyFields
    ? `\n     filterOptions: { ${buildFilterOptionStr(filterOptions)}\n     },`
    : ''
}

export const buildWidgetCode = (schedulingWidgetToken, options) =>
  `<script src="https://onlineschedulingv2.threadcommunication.com" type="text/javascript"></script>
 <script type="text/javascript">
   OpenChair.init({
     token: "${schedulingWidgetToken}",${options}
   })
 </script>`

export const defaultWidgetOptions = {
  demo: {
    value: false,
    label: 'Add the widget to the site in demo mode only',
  },
  mainButtonLeft: {
    value: false,
    label: 'Have the widget button appear on the lower left corner of website',
  },
  hideMainButton: {
    value: false,
    label: 'Hide the main scheduling widget button entirely',
  },
  hideTooltipHeader: {
    value: false,
    label:
      'Hide the text displaying the number of appointments available in the coming week',
  },
  zipCodeSearch: {
    value: false,
    label:
      'Replace time field with required zip code input to search for the nearest location',
  },
  skipDateSelection: {
    value: false,
    label: 'Makes widget jump directly from zipCodeSearch to booking selection. Only works with zipCodeSearch.',
  },
  disableMap: {
    value: false,
    label:
      "Disable maps so the widget won't interfere with other google maps on the site",
  },
  sortPerSpecificLocations: {
    value: false,
    label:
      'Sort locations by the order the "specificLocations" IDs were added. Requires specificLocations to be set.',
  },
  floatDownLocsWithoutBookings: {
    value: false,
    label:
      'Puts locations with no bookings to the bottom of the locations list per selected day.',
  },
  hideLocsWithoutBookings: {
    value: false,
    label: 'Hide locations without any available appointments',
  },
  textAreaRequired: {
    value: false,
    label: 'Makes the text area required',
  },
  postalCode: {
    value: false,
    label: 'Changes "Zip Code" label to "Postal Code".',
  },
}

export const messageInWidgetOptions = {
  contactPhoneNumber: {
    value: false,
    label: 'Contact Phone Number - This will appear at the bottom of the widget. Use only numbers and make sure you add the country code',
    textInput: '',
    placeholder: 'Enter phone number: "12223334444"',
  },
  customMessage: {
    value: false,
    label: 'Custom Message - This will replace the default message at the bottom of the widget container / dropdown.',
    textInput: '',
    placeholder: 'Enter custom message',
  },
  policyCheckbox: {
    value: false,
    label: "Add a checkbox to the widget for users to agree to the privacy policy. If you use the placeholder text, be sure to update PRACTICE_NAME and replace '/privacy-policy' with the correct URL.",
    textInput: "I have read and accept the <a href='/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy Policy</a>. By providing my phone number, I agree to receive text messages from PRACTICE_NAME. Message and data rates may apply. Message frequency varies.",
  },
  showPhoneMessageOnDropdown: {
    value: false,
    label: 'This will show the message on the bottom of the initial widget container (date picker / zipcode search).',
  },
  hideMessageOnMapRow: {
    value: false, // Note that this property, unlike the others, has an inverse relationship to its checkbox. When checked, the value is false.
    label: 'This will show the message on the bottom of the secondary widget container (booking selection).',
  },
  redirect: {
    value: false,
    label: 'Send the user to a thank you page or elsewhere. For best results, use a complete URL (including https://)',
    textInput: '',
    placeholder: 'Enter URL',
  },
};

export const defaultExtraQuestion = {
  question: {
    value: '',
    placeholder: 'ex: Do you have insurance?',
    label: 'Question:',
  },
  keyname: {
    value: '',
    placeholder: 'ex: has_insurance',
    label: 'Keyname (label associated with selected option):',
  },
  option1: {
    value: '',
    placeholder: 'ex: Yes',
    label: 'First Option:',
  },
  option2: {
    value: '',
    placeholder: 'ex: No',
    label: 'Second Option:',
  },
}

export const createDeepCopy = item => JSON.parse(JSON.stringify(item))

export const defaultApptTypeFilterOptions = [
  {
    id: 1,
    button: {
      value: '',
      placeholder: 'ex: Adult',
      label: 'First Button',
    },
    apptTypes: [],
  },
]

export const addFilterOptionButton = filterOptions => {
  const totalButtons = filterOptions.length
  const label = totalButtons === 1 ? 'Second Button' : 'Extra Button'

  if (totalButtons < 3) {
    const newButtonObj = {
      id: filterOptions[filterOptions.length - 1].id + 1, // for key
      button: {
        value: '',
        placeholder: '',
        label,
      },
      apptTypes: [],
    }
    return [...filterOptions, newButtonObj]
  }
  return filterOptions
}

export const copyToClipboard = str => {
  const devCodeSnippet = document.createElement('textarea')
  devCodeSnippet.innerText = str
  document.body.appendChild(devCodeSnippet)
  devCodeSnippet.select()
  document.execCommand('copy')
  devCodeSnippet.remove()
}



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/utils.js